import { render, staticRenderFns } from "./Portlet.vue?vue&type=template&id=8b4ba260&scoped=true&"
import script from "./Portlet.vue?vue&type=script&lang=js&"
export * from "./Portlet.vue?vue&type=script&lang=js&"
import style0 from "./Portlet.vue?vue&type=style&index=0&id=8b4ba260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4ba260",
  null
  
)

export default component.exports